import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { useStyles } from "./QualityButton.styles";

interface IQualityButtonProps {
    onClick: () => void;
    /**
     * When true the button visually pulses to nudge the operator that a new
     * hour interval has completed without a manual scrap entry. Driven by
     * `useQualityFlash` from the dashboard.
     */
    flashing?: boolean;
}

export const QualityButton = ({ onClick, flashing = false }: IQualityButtonProps) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Button
            className={`${classes.qualityButton} ${flashing ? classes.qualityButtonFlashing : ""}`}
            variant="contained"
            onClick={onClick}
        >
            {t("quality_button.label")}
        </Button>
    );
};
